/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { DownloadIcon, SearchIcon, TabOwnersIcon } from '../../../assets/icons';
import { classNames, Constants, formatMiles, fromStorage, getUpdatedState } from '../../../utils';
import { Input, Pagination, Select } from '../../../components';
import { ReportService } from '../../../services';

const ReportBillingRelation = () => {
  const { data, filters, goToPage, onChange, downloadAll, downloadOne, pagination, reload, search, selects } = useFetchTable();

  return (
    <main className="w-full">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex flex-1 flex-wrap items-end gap-3">
          <Input
            className={{ base: 'max-w-60' }}
            placeholder="Buscar nombre, CI, RIF"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Select
            className={{ base: 'max-w-44' }}
            placeholder="Estatus"
            items={selects.status}
            value={filters.status}
            onValueChange={v => onChange('status', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => search()}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-start">
        <div className="flex items-center gap-4 my-2">
          <Tab
            label="Propietarios"
            icon={TabOwnersIcon}
            isActive={filters.destiny === Constants.BILLING.DESTINY.OWNER}
            onClick={() => {
            onChange('destiny', Constants.BILLING.DESTINY.OWNER);
            search();
          }}
          />
          <Tab
            label="Conductores"
            icon={TabOwnersIcon}
            isActive={filters.destiny === Constants.BILLING.DESTINY.DRIVER}
            onClick={() => {
            onChange('destiny', Constants.BILLING.DESTINY.DRIVER);
            search();
          }}
          />
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Relación General de Pagos</p>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:whitespace-pre-line [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th>
                  <span hidden={filters.destiny !== Constants.BILLING.DESTINY.OWNER} className="pl-4">Propietario</span>
                  <span hidden={filters.destiny !== Constants.BILLING.DESTINY.DRIVER} className="pl-4">Conductor</span>
                </th>
                <th>CI/RIF</th>
                <th>Liquidación{'\n'}(Monto Total $)</th>
                <th>Liquidación{'\n'}(Monto Total Bs)</th>
                <th>Monto{'\n'}Pagado ($)</th>
                <th>Monto{'\n'}Pagado (Bs)</th>
                <th>Monto{'\n'}Pendiente ($)</th>
                <th>Monto{'\n'}Pendiente (Bs)</th>
                <th>Estatus de{'\n'}Liquidación</th>
                <th>Fecha registro{'\n'}del pago</th>
                <th align="right">Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <th>
                    <span className="pl-4">{ item?.user?.person?.name }</span>
                  </th>
                  <td>{ item?.user?.person?.document }</td>
                  <td>{ formatMiles(item?.total) }</td>
                  <td>{ formatMiles(item?.total_local, true, 'Bs. ') }</td>
                  <td>{ item?.paid > 0 ? formatMiles(item?.paid) : '--' }</td>
                  <td>{ item?.paid > 0 ? formatMiles(item?.paid_local, true, 'Bs. ') : '--' }</td>
                  <td>{ item?.pending > 0 ? formatMiles(item?.pending) : '--' }</td>
                  <td>{ item?.pending > 0 ? formatMiles(item?.pending_local, true, 'Bs. ') : '--' }</td>
                  <td>
                    <span className="data-[status=0]:text-red font-semibold" data-status={item?.status}>
                      { item?.status === Constants.BILLING.STATUS.PAID ? 'Pagado' : 'Pendiente' }
                    </span>
                  </td>
                  <td>{ item?.paid_at ? moment(item?.paid_at).format('DD/MM/YYYY') : '--' }</td>
                  <td>
                    <img
                      src={DownloadIcon}
                      className="w-5 h-5 object-contain cursor-pointer"
                      onClick={() => {
                        toast.promise(
                          downloadOne(item?.user_id),
                          {
                            loading: 'Descargando...',
                            success: 'Reporte impreso con éxito',
                            error: 'Error al imprimir el reporte',
                          }
                        );
                      }}
                      alt=""
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">No se han encontrado registros</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const Tab = ({ label, icon, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={classNames('flex items-center gap-2 p-3 rounded-xl text-sm font-semibold shadow-md', isActive ? 'bg-orange' : 'bg-white')}
  >
    <div className={classNames('w-10 h-10 rounded-full flex items-center justify-center', isActive ? 'bg-white' : 'bg-[#F5F7FA]')}>
      <img src={icon} className={classNames('w-5 h-5 object-contain', isActive ? 'text-white' : 'text-orange')} alt="" />
    </div>
    <span className={classNames(' text-lg', isActive ? 'text-white' : 'black')}>{ label }</span>
  </button>
)

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    destiny: Constants.BILLING.DESTINY.OWNER,
    search: '',
    status: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects] = useState({
    status: [
      { value: Constants.BILLING.STATUS.PENDING, label: 'Pendiente' },
      { value: Constants.BILLING.STATUS.PAID, label: 'Pagado' },
    ],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await ReportService.admin.billing.findByRelationAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await ReportService.admin.billing.downloadByRelationAll(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadOne = async (id) => {
    try {
      const response = await ReportService.admin.billing.downloadByRelationOne(id);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters({ ...initialFilters, destiny: filters.destiny });
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    downloadAll,
    downloadOne,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    selects,
  }
}

export default ReportBillingRelation;